/* eslint-disable jsx-a11y/label-has-associated-control */
import clsx from 'clsx'
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
    ReactNode,
    forwardRef,
    useState,
    type InputHTMLAttributes,
} from 'react'

export enum InputStyles {
    solid = 'input--solid',
    outline = 'input--outline',
}
interface InputProps extends InputHTMLAttributes<HTMLTextAreaElement> {
    label?: string
    error?: string
    inputStyle?: InputStyles
    afterLabel?: ReactNode
    togglePasswordShow?: boolean
    rows?: number
}

const TextArea = forwardRef<HTMLTextAreaElement, InputProps>(
    (
        {
            label,
            error,
            inputStyle = InputStyles.solid,
            afterLabel,
            togglePasswordShow,
            rows = 5,
            ...rest
        },
        ref,
    ) => {
        return (
            <div className="form-group input--lg w-full">
                {label && (
                    <div className="form-group-label">
                        <label className="label">{label}</label>
                        {afterLabel}
                    </div>
                )}
                <div className="w-full relative">
                    <textarea
                        className={clsx(
                            'textarea input--lg w-full',
                            rest.className,
                            inputStyle,
                        )}
                        ref={ref}
                        rows={rows}
                        {...rest}
                    ></textarea>
                </div>
                {error && (
                    <label className="form-label">
                        <div
                            className="label--text"
                            style={{ color: 'var(--danger)' }}
                        >
                            <span>{error}</span>
                        </div>
                    </label>
                )}
            </div>
        )
    },
)

export default TextArea
